import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
@UntilDestroy()

@Component({
  selector: 'app-member-detail-modal',
  templateUrl: './member-detail-modal.component.html',
  styleUrls: ['./member-detail-modal.component.css']
})
export class MemberDetailModalComponent implements OnInit {
  @Input() memberDetailsObj: any
  @Output() closeModal = new EventEmitter<any>();
  currentPage: number = 1;
  member: any;
  selectedMember: any = '';
  appointmentTypes: any = [];
  preAppointmentTypes: any = {};
  preSpaceTypeList: any = {};

  constructor(private memberService: MemberService,
    private spaceTypeService: SpaceTypeService,
    private appointmentType: AppointmentTypeService,
  ) { }

  ngOnInit(): void {
    this.getMembersById();
    this.getAppointmentTypes();
    this.getSpaceType();
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  getMembersById() {
    this.memberService.getMemberById(this.memberDetailsObj.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.member = data
      }
    })
  }
  getAppointmentTypes() {
    this.appointmentType.getPicker({ isActive: true, limit: 999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.appointmentTypes = data.results
        this.preAppointmentTypes = this.appointmentTypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getSpaceType() {
    this.spaceTypeService.getPicker().pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.preSpaceTypeList = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

}
